import { useQuery } from "@tanstack/react-query";
import { publicApi } from "@/api/client";

export function useSalon() {
  return useQuery({ queryKey: ["salon"], queryFn: publicApi.salon, staleTime: 5 * 60_000 });
}
